import React, { useEffect, useState } from "react";
import Toggle from "@atlaskit/toggle";
import { Inline, Box } from "@atlaskit/primitives";
import { Label } from "@atlaskit/form";
import { useDispatch, useSelector } from "react-redux";
import { selectFlow, setEditorSaved } from "../../../../redux/actions/integrationActions";
import SectionMessage, { SectionMessageAction } from "@atlaskit/section-message";
const UseStaticIP = () => {
  const flow = useSelector((state) => state.integration.flow);
  const dispatch = useDispatch();
  const [enabled, setEnabled] = useState(Boolean(flow?.useStaticIP));

  useEffect(() => {
    setEnabled(Boolean(flow?.useStaticIP));
  }, [flow?.useStaticIP]);

  const toggleStaticIP = () => {
    const nextValue = !enabled;
    setEnabled(nextValue);
    const updatedFlow = { ...flow, useStaticIP: nextValue };
    dispatch(selectFlow(updatedFlow));
    dispatch(setEditorSaved(false));
  };

  return (
    <>
      <Inline>
        <Box
          style={{
            display: "grid",
            gridTemplateColumns: "200px auto",
            alignItems: "center",
          }}
        >
          <Label>Use static IP</Label>
          <Toggle id="use-static-ip-toggle" size="regular" isChecked={enabled} onChange={toggleStaticIP} />
        </Box>
      </Inline>
      {enabled ? (
        <Inline>
          <SectionMessage title="Uses static IP 52.210.78.237">
            <p>
              {" "}
              Strongly advised to use only when necessary (e.g., company private services), not recommended for public services such as
              Google, Microsoft, Atlassian, etc.
            </p>
          </SectionMessage>
        </Inline>
      ) : null}
    </>
  );
};

export default UseStaticIP;
